import { render, staticRenderFns } from "./ProductKeyboard.vue?vue&type=template&id=1c97537d"
import script from "./ProductKeyboard.vue?vue&type=script&lang=js"
export * from "./ProductKeyboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports